import React, { useEffect, useState, useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { AppContext } from '@thd-nucleus/app-render';
import { DELETED_KEY_TAG } from '../../../constants/response-success-messages';
import { getNewPageNumber, hasNoPaymentCards } from '../../../utils/payments';
import { scrollToTop } from '../../../utils/general';
import { Pagination } from '../../shared/pagination/pagination';
import { Spinner } from '../../shared/spinner/spinner';
import { usePayments } from '../../../hooks/use-payments';
import { Alert } from '../../shared/alert/alert';
import { PaymentsHeader } from '../payments-header/payments-header';
import { CardType } from '../../../constants/payments';
import { KeytagCard } from '../keytags/keytags-card';
import { TAlertStatus } from '../../../models/common/alert-messages';
import { NoPaymentCardsMessage } from '../../shared/no-payment-cards-message/no-payment-cards-message';
export const KeytagsList = () => {
    var _a;
    const [deletedCreditCardIndex, setDeletedCreditCardIndex] = useState(null);
    const { loading, keytags, paginationInfo, currentPageNumber, alertMessage, getPaymentCards, setAlertMessage, } = usePayments();
    const { channel } = useContext(ExperienceContext);
    const { instance } = useContext(AppContext);
    const isB2B = ((_a = instance === null || instance === void 0 ? void 0 : instance.customer) === null || _a === void 0 ? void 0 : _a.type) === 'b2b';
    const isMobile = channel === 'mobile';
    const totalPages = Number(paginationInfo === null || paginationInfo === void 0 ? void 0 : paginationInfo.totalPages) || 0;
    useEffect(() => {
        return () => {
            setAlertMessage(null);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const triggerGetPaymentCards = (pageNumber) => {
        return getPaymentCards(CardType.KEY_TAG, false, false, {
            page: pageNumber,
        });
    };
    const getKeytagsList = () => {
        var _a;
        const keytagsList = ((_a = keytags === null || keytags === void 0 ? void 0 : keytags.paymentCards) === null || _a === void 0 ? void 0 : _a.map((account, index) => (React.createElement("div", { key: account.cardNumber, className: `sui-flex ${isMobile ? 'sui-flex-col' : ''}` },
            React.createElement(KeytagCard, { key: account.cardNumber, card: account, setDeletedCreditCardIndex: setDeletedCreditCardIndex, index: index, isMobile: isMobile, onActionSuccess: handleSuccess, onActionFailure: handleError }))))) || null;
        if (isMobile && deletedCreditCardIndex !== null && keytagsList !== null) {
            keytagsList.splice(deletedCreditCardIndex, 0, React.createElement(React.Fragment, null, successMessage));
        }
        return keytagsList;
    };
    const handleSuccess = (cardNumber, message) => {
        setAlertMessage({
            paymentId: cardNumber,
            alertStatus: TAlertStatus.SUCCESS,
            text: message,
        });
        if (message === DELETED_KEY_TAG.message) {
            const newPage = getNewPageNumber(currentPageNumber, totalPages, isB2B
                ? paginationInfo === null || paginationInfo === void 0 ? void 0 : paginationInfo.paymentsOnCurrentPage
                : keytags === null || keytags === void 0 ? void 0 : keytags.paymentCards.length);
            // ensure user stays on the same page or on the previous page (if last payment deleted) to show delete confirmation
            onChangePage(newPage);
            return;
        }
        onChangePage(1);
    };
    // We are using cardNumber because keytags do not have paymentId
    const handleError = (cardNumber, message) => {
        setAlertMessage({
            paymentId: cardNumber,
            alertStatus: TAlertStatus.ERROR,
            text: message,
        });
    };
    const onChangePage = (newPageNumber) => {
        triggerGetPaymentCards(newPageNumber);
    };
    const successMessage = alertMessage &&
        alertMessage.alertStatus === TAlertStatus.SUCCESS && (React.createElement("div", { className: "sui-mt-4 sm:sui-mt-0 lg:sui-mb-8" },
        React.createElement(Alert, { status: alertMessage.alertStatus, onClose: () => setAlertMessage(null) }, alertMessage.text)));
    const desktopErrorMessage = !isMobile &&
        alertMessage &&
        alertMessage.alertStatus === TAlertStatus.ERROR && (React.createElement("div", { className: "lg:sui-mb-8" },
        React.createElement(Alert, { status: alertMessage.alertStatus, onClose: () => setAlertMessage(null) }, alertMessage.text)));
    return (React.createElement(React.Fragment, null,
        React.createElement(Spinner, { active: loading }),
        React.createElement(PaymentsHeader, { cardType: CardType.KEY_TAG, onActionFailure: handleError, onActionSuccess: handleSuccess }),
        !isMobile && successMessage,
        desktopErrorMessage,
        hasNoPaymentCards(keytags) && (React.createElement(NoPaymentCardsMessage, { tenderType: CardType.KEY_TAG })),
        React.createElement("div", { className: "sui-grid sui-grid-cols-1 sui-gap-y-8 sui-gap-x-8 md:sui-grid-cols-2 2xl:sui-gap-y-16 2xl:sui-grid-cols-3" }, getKeytagsList()),
        totalPages > 1 && (React.createElement("div", { className: "sui-w-full sui-justify-center sui-p-5 sui-flex" },
            React.createElement(Pagination, { nPages: totalPages, onChangePage: (newPage) => {
                    onChangePage(newPage);
                    setAlertMessage(null);
                    scrollToTop();
                }, page: currentPageNumber })))));
};
